// AddPrescriptionApiSlice.js
import { apiSlice } from "./ApiSlice";

const AddPrescriptionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    addPrescription: builder.mutation({
      query: (payload) => ({
        url: "/api/ClinicProfile/AddPrescription",
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Prescription"],
    }),

    PostFilteredPrescription: builder.mutation({
      query: (data) => ({
        url: `/api/ClinicProfile/PrescriptionsTableFilter`,
        method: "POST",
        body: data,
      }),
    }),

    getPatientListView: builder.query({
      query: (userclinicid) => ({
        url: `/api/ClinicProfile/GetPatientListView?userclinicid=${userclinicid}`,
        method: "GET",
      }),
    }),

    GetBookedPatientsPrescriptionDropdown: builder.query({
      query: ({
        userClinicID,
        doctorUserUniqueID,
        appointmentDate,
        userUniqueID,
      }) => ({
        url: `/api/ClinicProfile/GetAppointmentBookedPatientsPrescriptionDropDown?userClinicID=${userClinicID}&doctorUserUniqueID=${doctorUserUniqueID}&appointmentDate=${appointmentDate}&userUniqueID=${userUniqueID}`,
        method: "GET",
      }),
    }),


    GetPrescriptionListView: builder.query({
  query: ({ userClinicID, doctorUserUniqueID }) => ({
    url: `/api/ClinicProfile/GetPrescriptionListView?userClinicID=${userClinicID}&doctorUserUniqueID=${doctorUserUniqueID}`,
    method: "GET",
  }),
  providesTags: ["Prescription"],
}),


GetFullPrescriptionDetails: builder.query({
  query: ({ userUniqueID,appointmentID,userClinicID }) => ({
    url: `/api/ClinicProfile/GetFullPrescriptionDetails?patientUserUniqueID=${userUniqueID}&appointmentID=${appointmentID}&userClinicID=${userClinicID}`,
    method: "GET",
  }),
}),

GetPrescriptionDetailsByPatient: builder.query({
  query: ({ userUniqueID, appointmentID}) => ({
    url: `/api/ClinicProfile/GetprecriptionDetailsByPatient?PatientUserUniqueID=${userUniqueID}&appointmentID=${appointmentID}`,
    method: "GET",
  }),
}),

Getallprescriptiondata: builder.query({
      query: ({clinicUserId,userUniqueID,prescriptionId}) => {
        
        return {
          url: `/api/ClinicProfile/GetFullPrescriptionDetails?userUniqueID=${userUniqueID}&userClinicID=${clinicUserId}&prescriptionID=${prescriptionId}`,
          method: "GET"
        };
      },
    }),

 Getallprescription: builder.query({
      query: (clinicUserId) => {
        
        return {
          url: `/api/ClinicProfile/GetPrescriptionListView?userClinicID=${clinicUserId}`,
          method: "GET"
        };
      },
    }),

    Getprescriptionpatienthistory: builder.query({
      query: (patientUserUniqueID) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Prescription-History?patientUserUniqueID=${patientUserUniqueID}`,
          method: "GET"
        };
      },
    }),

     Getprescriptiondoctorhistory: builder.query({
      query: ({patientUserUniqueID,DoctorUserUniqueID}) => {
        return {
          url: `/api/ClinicProfile/GetPatientOverview-Prescription-History?patientUserUniqueID=${patientUserUniqueID}&doctorUserUniqueID=${DoctorUserUniqueID}`,
          method: "GET"
        };
      },
    }),

  }),
});

export const {
  useAddPrescriptionMutation,
  usePostFilteredPrescriptionMutation,
  useGetPrescriptionDetailsByPatientQuery,
  useLazyGetPrescriptionDetailsByPatientQuery,
  useLazyGetFullPrescriptionDetailsQuery,
  useLazyGetBookedPatientsPrescriptionDropdownQuery,
  useGetPatientListViewQuery,
  useLazyGetPatientListViewQuery,
    useGetPrescriptionListViewQuery,
    useLazyGetallprescriptiondataQuery,
    useLazyGetallprescriptionQuery,
    useLazyGetprescriptionpatienthistoryQuery, 
    useLazyGetprescriptiondoctorhistoryQuery
} = AddPrescriptionApiSlice;
